"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  CustomerCircleDescription = _require.CustomerCircleDescription;
const formatRelatedProducts = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const modTitle = properties.modTitle,
    color = properties.color,
    list = properties.list,
    _properties$colorThem = properties.colorTheme,
    colorTheme = _properties$colorThem === void 0 ? '' : _properties$colorThem;
  if (!list) {
    return {
      modTitle,
      bgColor: color,
      configuration: [],
      colorTheme
    };
  }
  const configuration = list.map((item, index) => {
    const title = item.title,
      content = item.content,
      href = item.href,
      hrefText = item.hrefText,
      source = item.source;
    if (title || content) {
      // 标题和内容必须有，才会认为是正常数据，可以展示
      let itemData = {
        key: `${index + 1}`,
        title,
        content: formatUrlInText(content),
        source
      };
      if (href && hrefText) {
        // 链接地址和链接文案一起配置了才会当作是有效配置
        const formattedHref = formatUrlString(href);
        itemData = _objectSpread(_objectSpread({}, itemData), {}, {
          href: formattedHref,
          hrefText,
          extendProps: {
            'report-event': 'click_relatedProducts_href',
            'report-ext1': index,
            'report-ext2': hrefText,
            'report-ext3': formattedHref
          }
        });
      }
      return itemData;
    }
    return {};
  });
  return {
    modTitle,
    bgColor: color,
    configuration,
    colorTheme
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatRelatedProduct = formatRelatedProducts(data, {
        domains
      }),
      modTitle = _formatRelatedProduct.modTitle,
      configuration = _formatRelatedProduct.configuration,
      bgColor = _formatRelatedProduct.bgColor,
      colorTheme = _formatRelatedProduct.colorTheme;
    let bgStyle = {};
    if (colorTheme) {
      bgStyle = {
        background: colorTheme
      };
    } else {
      bgStyle = (0, _componentUtils.doComponentsBgColorEvent)(bgColor);
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_relatedProducts', componentKey, modTitle])), /*#__PURE__*/React.createElement(CustomerCircleDescription, {
      configuration: configuration,
      flexTitle: modTitle,
      style: bgStyle
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}